export default __webpack_public_path__ + "static/media/controller-blue.3e92f5ac.svg";